import { Utils } from '@core/utilities/utils';
import { LanguageType } from '../common/language-type.enum';

export class Preference {
    languageType: LanguageType;
    date: Date;

    constructor(languageType: LanguageType) {
        this.languageType = languageType;
        this.date = Utils.utcNow();
    }
}